<template lang='pug'>
  .fpui-accordion
    slot
</template>

<script>

export default {
  name: 'fpui-accordion',
  props: {
  },
  data () {
    return {
    }
  }
}
</script>

<style lang='less'>

</style>
